export const LISTE_ASSOCIATION = "liste-association";
export const ONGLET_DETAIL = "detail-association";
export const MODIFICATION_ASSOCIATION = "modification-association";
export const DISSOLUTION_ASSOCIATION = "dissolution-association";
export const RADIATION_ASSOCIATION = "radiation-association";

export function toDetailAssociation(numero) {
  return {
    name: ONGLET_DETAIL,
    params: { numero }
  }
}

export function toModificationAssociation(numero) {
  return {
    name: MODIFICATION_ASSOCIATION,
    params: { numero }
  }
}

export function toDissolutionAssociation(numero) {
  return {
    name: DISSOLUTION_ASSOCIATION,
    params: { numero }
  }
}

export function toRadiationAssociation(numero) {
  return {
    name: RADIATION_ASSOCIATION,
    params: { numero }
  }
}
